
import React from "react";
import { NavigationMenuItem, NavigationMenuTrigger, NavigationMenuContent } from "@/components/ui/navigation-menu";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { TabContentWithImage } from "./TabContent";

interface CustomersMenuProps {
  activeTab: string;
  onTabChange: (value: string) => void;
  allImagesLoaded: boolean;
}

export const CustomersMenu: React.FC<CustomersMenuProps> = ({
  activeTab,
  onTabChange,
  allImagesLoaded
}) => {
  return (
    <NavigationMenuItem>
      <NavigationMenuTrigger className="bg-transparent hover:bg-gray-200 text-primary text-sm font-medium">Customers</NavigationMenuTrigger>
      <NavigationMenuContent className="w-[95vw] min-w-[95vw] max-w-[1000px] h-[500px] bg-white rounded-md shadow-lg p-4 border border-gray-200">
        <Tabs value={activeTab} onValueChange={onTabChange} orientation="vertical" className="flex">
          <TabsList className="flex flex-col w-1/4 h-[450px] bg-gray-50 rounded-l-md space-y-1 p-2 border-r border-primary portrait:w-1/4 portrait:min-w-[120px]">
            <TabsTrigger value="asiapacific" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Asia Pacific
            </TabsTrigger>
            <TabsTrigger value="emea" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              EMEA
            </TabsTrigger>
            <TabsTrigger value="americas" className="w-full text-left pl-3 pr-3 text-primary-dark data-[state=active]:bg-primary data-[state=active]:text-white data-[state=active]:rounded-none min-w-[100px] portrait:min-w-[100px] portrait:text-xs portrait:px-2 portrait:w-full portrait:text-left portrait:justify-start">
              Americas
            </TabsTrigger>
          </TabsList>
          <TabsContent value="asiapacific" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1540959733332-eab4deabeeaf?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Asia Pacific"
              title="Asia Pacific"
              description="Serving diverse markets across Asia and Oceania with tailored AI solutions for regional business challenges."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="emea" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1467269204594-9661b134dd2b?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="EMEA"
              title="Europe, Middle East & Africa"
              description="Comprehensive AI solutions for EMEA businesses navigating complex regulatory environments and market dynamics."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
          <TabsContent value="americas" className="w-2/3 p-4 portrait:w-3/4 portrait:p-2 overflow-auto max-h-[450px]">
            <TabContentWithImage
              imageSrc="https://images.unsplash.com/photo-1569959220744-ff553533f492?w=400&h=300&fit=crop&auto=format&q=80&sat=-100"
              imageAlt="Americas"
              title="Americas"
              description="Innovative AI solutions for North and South American enterprises seeking competitive advantage through technology."
              allImagesLoaded={allImagesLoaded}
            />
          </TabsContent>
        </Tabs>
      </NavigationMenuContent>
    </NavigationMenuItem>
  );
};
